import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import { useEffect } from "preact/hooks"
import SubmitButton from "./elements/SubmitButton"
import Product from "./Product"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    function swymCallbackFn(swat) {
        document.addEventListener("swym:collections-loaded", function() {
            swat.initializeActionButtons(".nosto-products-wrap");
        })
    }
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);

    useEffect(() => {

        const isEmpty = !products?.hits?.length && !keywords?.hits?.length

        let inputValue = document.querySelector('.nosto-autocomplete-wrapper .search-bar__input')?.value

        setTimeout(() => {
            if(document.querySelector('.ns-no-results')) {
                document.querySelector('.ns-no-results').innerHTML = `
                <div class="ns-no-results-wrap">
                    <div class="ns-no-results-title">Sorry we couldn’t find <span>“${inputValue}”</span></div>
                    <div class="ns-no-results-subtitle">Try checking your spelling or using different words.</div>
                </div>`
    
                document.querySelector('.ns-no-results-wrap').classList.add('active')
            } else {
                if(document.querySelector('.ns-no-results-wrap')) {
                    document.querySelector('.ns-no-results-wrap').remove()
                }
            }

            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        }, 500);


        if (isEmpty) {
            const element = document.querySelector('.search-recommended-items')
            if (element) {
                document.querySelectorAll('.search-recommended-items').forEach(function(el) {
                    el.classList.remove('hidden')
                })
            }
        } else {
            const element = document.querySelector('.search-recommended-items')
            if (element) {
                document.querySelectorAll('.search-recommended-items').forEach(function(el) {
                    el.classList.add('hidden')
                })
            }
        }
    }, [products, keywords])

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return (
            <div class="ns-no-results"></div>
        )
    }

    return (
        <div
            class="autocomplete-content w-full flex"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="autocomplete-content-wrap">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class="autocomplete-keywords"
                        >
                            <div class="autocomplete-title color-text">Suggestions</div>
                            <div class="autocomplete-keywords__list">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="autocomplete-products w-full">
                            <div className="autocomplete-products-title-wrap">
                            <div class="autocomplete-title color-text">Found for You</div>
                                <SubmitButton text="Show all products" />
                            </div>
                     
                            <div class="autocomplete-content-products">
                                {products?.hits?.map(hit => {
                                    return (
                                        <Product
                                            product={hit}
                                            key={hit.productId}
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    class="color-text"
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
